import React from 'react';
import { CloseButton, CloseButtonSize } from '../LiliCloseButton';
import { Heading, useFontClass } from '../../tokens';

interface LiliDropDownValueTemplateProps {
  selectedValue: string | null;
  selectedTitle: string | null;
  title: string;
  onClear?: () => void;
  id?: string;
  showClear?: boolean;
  disabled?: boolean;
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const LiliDropDownValueTemplate = ({
  selectedValue,
  selectedTitle,
  title,
  onClear,
  id,
  showClear,
  disabled,
  Icon,
}: LiliDropDownValueTemplateProps) => {
  const { fontClass } = useFontClass();

  return (
    <div
      className='flex flex-row items-center gap-1 overflow-hidden'
      key={selectedValue || selectedTitle}
      id={`dropdown-item-${selectedValue || selectedTitle}`}>
      <div className='flex gap-[6px] items-center min-w-0 overflow-hidden'>
        {Icon && (
          <Icon className='max-w-[24px] max-h-[24px] text-text-main-tertiary flex-shrink-0' />
        )}
        {!selectedValue ? (
          <Heading.H9 className={`${fontClass} text-text-main-tertiary truncate`}>
            {title}
          </Heading.H9>
        ) : (
          <Heading.H9
            className={`${fontClass} ${disabled ? 'text-text-main-tertiary' : 'text-text-main-primary'} truncate`}>
            {selectedTitle}
          </Heading.H9>
        )}
      </div>
      {onClear && selectedValue && showClear && !disabled && (
        <CloseButton
          id={`clear-icon-${id}`}
          onClick={onClear}
          className='w-[18px] h-[18px] mr-[0px]'
          size={CloseButtonSize.Small}
        />
      )}
    </div>
  );
};
